import React from 'react';
import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const JiraCompanyManagedGlyph = (props: CustomGlyphProps) => (
	<svg
		fill="none"
		height="24"
		viewBox="0 0 24 24"
		width="24"
		xmlns="http://www.w3.org/2000/svg"
		data-testid={props['data-testid']}
		aria-label={props['aria-label']}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={props.className}
	>
		<rect fill="currentColor" height="24" rx="12" width="24" />
		<path d="m4 4h16v16h-16z" fill="currentColor" fill-opacity=".01" />
		<g fill="inherit">
			<path d="m7.33933 8h1.994v2.6667h-1.33333v1.3333h1.33333v.6667h-1.33333v1.3333h1.33333v4h-1.994c-.73933 0-1.33933-.64-1.33933-1.4333v-7.13337c0-.792.60133-1.43333 1.33933-1.43333z" />
			<path
				clip-rule="evenodd"
				d="m11.3393 6c-.738 0-1.3393.59533-1.3393 1.33v10.67h6.6607c.3538.0009.6936-.1387.9447-.388.2511-.2494.393-.5881.3946-.942v-9.34c0-.73467-.5993-1.33-1.3393-1.33zm1.994 2.66667h-1.3333v1.33333h1.3333zm0 2.00003h-1.3333v1.3333h1.3333zm0 2h-1.3333v1.3333h1.3333zm1.3334 2h-1.3334v2h1.3334zm1.3333-6.00003h-1.3333v1.33333h1.3333zm0 2.00003h-1.3333v1.3333h1.3333zm0 2h-1.3333v1.3333h1.3333z"
				fill-rule="evenodd"
			/>
		</g>
	</svg>
);

const JiraCompanyManagedIcon = (props: IconProps) => (
	<Icon {...props} glyph={JiraCompanyManagedGlyph} />
);

export default JiraCompanyManagedIcon;
